import { render, staticRenderFns } from "./AssessmentPreviousBatchData.vue?vue&type=template&id=6b68fbcc"
import script from "./AssessmentPreviousBatchData.vue?vue&type=script&lang=js"
export * from "./AssessmentPreviousBatchData.vue?vue&type=script&lang=js"
import style0 from "./AssessmentPreviousBatchData.vue?vue&type=style&index=0&id=6b68fbcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports